import { useState } from 'react';
import { Col, FormGroup, Label, CustomInput } from '@polichat/flamboyant';
import { useGlotaT } from '../../../../../hooks/useGlotaTranslation';

function TemplateSelectBuilderType({
  onUpdate,
  initialValue: { templateTypeList, initialTemplateType },
  isEdit,
}) {
  // Traduções
  const messageType = useGlotaT('spa.messageBuilder.messageType');
  
  const [templateType, setTemplateType] = useState({
    templateType: initialTemplateType,
  });

  const handleInputChange = ({ target: { name, value } }) => {
    setTemplateType({
      ...templateType,
      [name]: value,
    });
    handleTemplateTypeData({
      ...templateType,
      [name]: value,
    });
  };

  const handleTemplateTypeData = (data) => {
    onUpdate(data);
  };

  return (
    <Col sm={12} md={6}>
      <FormGroup>
        <Label>{messageType}</Label>
        <CustomInput
          type="select"
          id="template-type"
          name="templateType"
          value={templateType.templateType}
          onChange={handleInputChange}
          required
          disabled={isEdit}
        >
          <optgroup label={messageType}>
            {templateTypeList.map((type) => (
              <option key={type.id} disabled={!type.active} value={type.type}>
                {type.description}
              </option>
            ))}
          </optgroup>
        </CustomInput>
      </FormGroup>
    </Col>
  );
}

export default TemplateSelectBuilderType;
